import React from 'react'
import { Link } from 'gatsby'
import { StaticImage } from 'gatsby-plugin-image'
import { Col, Row }  from 'react-bootstrap'

import './product_range_block.scss'

export const ProductRangeBlock = () => {
  return (
    <div className="product-range-block">
      <Row className="mt-5">
        <Col sm={12} className="d-flex align-items-center justify-content-center">
          <div className="title-container">
            <h1 className="title">Our Product Range</h1>
          </div>
        </Col>
      </Row>
      <Row className="mt-5 mb-4">
      <Col md={6} lg={4}>
          <Link className="product-range-item" to="/products/livestock-handling">
            <StaticImage 
              src="../../../../images/livestock-landling-metalcorp-yard-1.jpg" 
              alt="Livestock Handling"
              width={335}
              height={280}
              placeholder="blurred"
              layout="fixed" />
              <div className="title-container">
                <h3>Livestock Handling</h3>
              </div>
          </Link>
        </Col>
        <Col md={6} lg={8}>
          <Link className="product-range-item" to="/products/fencing">
            <StaticImage 
              src="../../../../images/fencing-metalcorp-1.jpg" 
              alt="Fencing"
              width={695}
              height={280}
              placeholder="blurred"
              layout="fixed" />
              <div className="title-container">
                <h3>Fencing</h3>
              </div>
          </Link>
        </Col>
        <Col md={6} lg={8} className="mb-4 mt-4">
          <Link className="product-range-item" to="/products/tubular-steel">
            <StaticImage 
              src="../../../../images/tubular-steel-category.jpeg" 
              alt="Tubular steel"
              width={695}
              height={280}
              placeholder="blurred"
              layout="fixed" />
              <div className="title-container">
                <h3>Tubular Steel</h3>
              </div>
          </Link>
        </Col>
        <Col md={6} lg={4} className="mb-4 mt-4">
          <Link className="product-range-item" to="/products/structural-merchant-bar">
            <StaticImage 
              src="../../../../images/merchant-bar-category.png" 
              alt="Merchant bar"
              width={335}
              height={280}
              placeholder="blurred"
              layout="fixed" />
              <div className="title-container">
                <h3>Structural Merchant Bar</h3>
              </div>
          </Link>
        </Col>
        <Col md={6} lg={4}>
        <Link className="product-range-item" to="/products/all">
            <StaticImage 
              src="../../../../images/accessories-category.jpeg" 
              alt="All"
              width={335}
              height={280}
              placeholder="blurred"
              layout="fixed" />
              <div className="title-container">
                <h3>All</h3>
              </div>
          </Link>
        </Col>
        <Col md={6} lg={8}>
        <Link className="product-range-item" to="/products/other">
            <StaticImage 
              src="../../../../images/other-2.jpg"
              alt="Accessories"
              width={695}
              height={280}
              placeholder="blurred"
              layout="fixed" />
              <div className="title-container">
                <h3>Accessories</h3>
              </div>
          </Link>
        </Col>
      </Row>
    </div>
  )
}

export default ProductRangeBlock